import React, { MouseEvent, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  focusMainContent,
  MAIN_CONTENT_ID,
  prepareSkipLinkAsNextTabTarget,
} from '../../lib/helpers/skipToMainContent';
import './SkipToMainContent.scss';

export const SKIP_TO_MAIN_CONTENT_TEST_ID = 'skip-to-main-content';

const SkipToMainContent: React.FC = (): JSX.Element => {
  const { pathname } = useLocation();
  useEffect(() => {
    prepareSkipLinkAsNextTabTarget();
  }, [pathname]);

  const handleClick = (event: MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault();
    event.stopPropagation();
    focusMainContent();
  };

  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      className='skip-to-main-content'
      onClick={handleClick}
      data-test-id={SKIP_TO_MAIN_CONTENT_TEST_ID}
    >
      skip to main content
    </a>
  );
};

export default SkipToMainContent;
